export const calculatorCurrencyValues = [
    'CAD',
    'USD',
    'EUR',
    'R$',
    'MXN',
    'CHF',
    'GPB',
    'CZK',
    'DKK',
    'HUF',
    'NOK',
    'RUB',
    'SEK',
    'TRY',
] as const;

export type CalculatorCurrencyValuesType = typeof calculatorCurrencyValues[number];

